import { useTranslation } from "react-i18next";
import { scorePassword } from "../../lib/passwordPolicy";

const LEVELS = [
  { key: "weak", bar: "bg-destructive", text: "text-destructive" },
  { key: "weak", bar: "bg-destructive", text: "text-destructive" },
  { key: "fair", bar: "bg-orange-500", text: "text-orange-500" },
  { key: "good", bar: "bg-sky-500", text: "text-sky-500" },
  { key: "strong", bar: "bg-emerald-500", text: "text-emerald-600" },
];

export const PasswordStrength = ({ value, className = "" }) => {
  const { t } = useTranslation();
  if (!value) return null;
  const score = scorePassword(value);
  const level = LEVELS[score];

  return (
    <div className={className} data-testid="password-strength">
      <div className="flex gap-1.5">
        {[1, 2, 3, 4].map((step) => (
          <span
            key={step}
            className={`h-1.5 flex-1 rounded-full transition-colors duration-300 ${
              step <= score ? level.bar : "bg-muted"
            }`}
          />
        ))}
      </div>
      <p className={`mt-1 text-[11px] font-bold ${level.text}`} data-testid="password-strength-label">
        {t(`auth.strength.${level.key}`)}
      </p>
    </div>
  );
};

export { scorePassword };
